module.exports = __webpack_public_path__ + "img/inchcape.43ccce01.png";